
export default defineNuxtPlugin(() => {
  callAfterDocumentIdle(() => {
    import('@layers/web/assets/scss/lazy-style.scss')
  }, 1000)
})